import { gql } from '@apollo/client';
import {
  AlertDescription,
  Box,
  chakra,
  HStack,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@chakra-ui/react';
import { isNil } from 'lodash';
import { MutableRefObject } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import BackToAllActionsButton from '~components/displays/BulkAction/BackToAllActionsButton';
import { useManageWebPagesForm } from '~components/displays/useManageWebPagesForm';
import { WarningAlert } from '~components/ui/Alert';
import { BulkActionComponent } from './BulkActionModal';

export const BulkEditWebPages: BulkActionComponent = ({
  initialFocusRef,
  displays,
  onCancel,
  onSuccess,
  onBack,
}) => {
  const { t } = useTranslation();
  const webPagesNotSupported = displays.filter((display) =>
    isNil(display.bookmarks?.all?.reported),
  );
  const webPagesNotSupportedCount = webPagesNotSupported.length;
  const webPagesNotSupportedAlias =
    webPagesNotSupportedCount === 1 ? webPagesNotSupported[0].alias : null;
  const { body, footer, onSubmit } = useManageWebPagesForm({
    displayIds: displays.map((display) => display.id),
    onSuccess: onSuccess,
    onCancel: onCancel,
    initialFocusRef: initialFocusRef as MutableRefObject<HTMLInputElement>,
    defaultBookmarks: [],
    webPagesNotSupportedCount,
  });
  return (
    <ModalContent>
      <ModalHeader>{t('editWebPages')}</ModalHeader>
      <ModalCloseButton onClick={onCancel} />

      <form onSubmit={onSubmit}>
        {webPagesNotSupportedCount > 0 && (
          <Box px="7" py="8">
            <WarningAlert>
              <AlertDescription>
                {' '}
                <Trans
                  i18nKey="webPagesNotSupported"
                  count={webPagesNotSupportedCount}
                  values={{
                    name: webPagesNotSupportedAlias,
                    count: webPagesNotSupportedCount,
                  }}
                  components={{
                    strong: <chakra.strong />,
                  }}
                />
              </AlertDescription>
            </WarningAlert>
          </Box>
        )}
        {webPagesNotSupportedCount == 0 && <ModalBody>{body}</ModalBody>}
        <ModalFooter>
          <HStack flex="1" justifyContent="space-between">
            <BackToAllActionsButton onBack={onBack} />
            <Box>{footer}</Box>
          </HStack>
        </ModalFooter>
      </form>
    </ModalContent>
  );
};

BulkEditWebPages.graphql = {
  fragments: {
    BulkEditWebPages_display: gql`
      fragment BulkEditWebPages_display on Display {
        id
        bookmarks {
          all {
            reported
            desired
          }
        }
      }
    `,
  },
};
